import { uploadService } from './uploadService'
import { fileService } from './fileService'

/**
 * Adjuntos de un ticket recién creado: sube cada archivo a Storage y registra
 * su metadata en `Tickets.file`. Compone `uploadService` + `fileService`.
 *
 * @namespace ticketAttachmentService
 */
const ticketAttachmentService = {
  /**
   * Sube y registra los archivos de un ticket. Un archivo que falla no
   * detiene al resto: se devuelve en `failed`.
   *
   * @param {number|string} ticketId
   * @param {Array<{file: File}>} files - Elementos de `FileDrop`.
   * @param {string} userId - `auth.uid` de quien sube.
   * @returns {Promise<{success: boolean, data: {uploaded: string[], failed: string[]}}>}
   */
  async attach(ticketId, files = [], userId) {
    const uploaded = []
    const failed = []

    for (const { file } of files) {
      try {
        const upload = await uploadService.uploadFile(file, ticketId, userId)
        const { success, error } = await fileService.insert({
          id: null,
          ticketId,
          commentId: null,
          url: upload.url,
          name: file.name,
          mimeType: file.type,
          size: file.size,
          createdAt: new Date().toISOString(),
          solutionId: null,
          uploadedBy: userId,
        })
        if (!success) throw new Error(error)
        uploaded.push(file.name)
      } catch (error) {
        console.error(`Error adjuntando ${file.name}:`, error)
        failed.push(file.name)
      }
    }

    return { success: failed.length === 0, data: { uploaded, failed } }
  },
}

export default ticketAttachmentService
